import CantLoad from "./assets/cant-load.svg?component";
import {
  errorHeadingStyle,
  errorMessageStyle,
  errorStyle,
} from "./FullWidthLoadingError.style";

interface FullWidthLoadingErrorProps {
  /**
   * error header displayed in a h3
   */
  header?: string;
  /**
   * error message to be displayed below the header
   */
  message?: string;
}

export const errorHeader = "Unable to load student data";

export const errorMessage =
  "An error occurred while loading this data. Please refresh the page or try again later";

export const FullWidthLoadingError = (props: FullWidthLoadingErrorProps) => {
  const { header = errorHeader, message = errorMessage } = props;
  return (
    <div css={errorStyle}>
      <CantLoad />
      <h3 css={errorHeadingStyle}>{header}</h3>
      <p css={errorMessageStyle}>{message}</p>
    </div>
  );
};
